module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#rint"
    }
  }, [_vm._v("Me: An Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Part1#rpt1"
    }
  }, [_vm._v("FLOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter1#rch1"
    }
  }, [_vm._v("The Home Place")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter2#rch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mamatha Takes Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter3#rch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Good Name")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter4#rch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Field Guide to the Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter5#rch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First-Sunday God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "pt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part2#rpt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLEDGLING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter6#rch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Brown Icarus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter7#rch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whose Eye Is on the Sparrow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter8#rch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter9#rch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life’s Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "pt3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Part3#rpt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter10#rch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bluebird of Enlightenment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter11#rch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hoops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter12#rch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Birding While Black")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter13#rch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jawbone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter14#rch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter15#rch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thinking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter16#rch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter17#rch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Reunion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter18#rch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patchwork Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgement#rack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 69
// module chunks = 0